import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';

interface IComponentInteractionClasse {
    codigo: number;
    componentInteraction: number;
    fadClasses: number;
}

class ComponentInteractionClasse extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(Number)
    componentInteraction: number = -1;

    @jsonProperty(Number)
    fadClasses: number = -1;

    fromJSON(json: IComponentInteractionClasse, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.componentInteraction = json.componentInteraction;
        this.fadClasses = json.fadClasses;

        return this;
    }
}

export default ComponentInteractionClasse;
